import { render } from "./NgongVegBanner.vue?vue&type=template&id=600ba26d&scoped=true"
import script from "./NgongVegBanner.vue?vue&type=script&lang=js"
export * from "./NgongVegBanner.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-600ba26d"

export default script